import React from 'react';
import { camelCasify } from 'Components/utils/string/string.util';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { TeaserCards } from 'Components/widgets/teaser-cards/TeaserCards';
type Props = {
  cards: Array<{
    image: string;
    layerTitle: string;
    layerDescription: string;
    layerBlocks: Array<{
      text: string;
      title: string;
    }>;
    seeMoreLabel: string;
    seeMoreUrl: string;
    subtitle?: string;
    title: string;
  }>;
  config: CMSContent;
  header: string;
  id: string;
  tabId?: string;
  title: string;
};
export const TeaserCardsLine = ({
  cards,
  config: {
    common: { backNavigation, scrollBackward, scrollForward },
  },
  header,
  id,
  tabId,
  title,
}: Props) => {
  const track = useTracking();
  const teaserCards = (cards || []).map(({ seeMoreUrl, title: cardtitle, ...rest }) => ({
    ...rest,
    link: {
      onClick: () =>
        track({
          actionGA: title,
          labelGA: `card_${cardtitle}`,
        }),
      url: seeMoreUrl,
    },
    title: cardtitle,
  }));
  return (
    <SiteContainer className="Line" id={id}>
      <LineTitle>{title}</LineTitle>
      <TeaserCards
        backNavigationLabel={backNavigation}
        cards={teaserCards}
        scrollBackwardLabel={scrollBackward}
        scrollForwardLabel={scrollForward}
        sliderQueryName={camelCasify(header + (tabId || ''))}
      />
    </SiteContainer>
  );
};
